// Import default images
import completedSmallImg from 'assets/images/deposit/deposit_img_completed_normal.png'
import completedLargeImg from 'assets/images/deposit/deposit_img_completed_normal_l.png'
import noBonusSmallImg from 'assets/images/deposit/deposit_img_nobonus_normal.png'
import noBonusLargeImg from 'assets/images/deposit/deposit_img_nobonus_normal_l.png'
import promoCodeLargeImg from 'assets/images/mission/promocode/mission_img_promocode.png'
import promoCodeSmallImg from 'assets/images/mission/promocode/mission_img_promocode_s.png'
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

const campaignDefaultMapping = {
  noBonus: {
    campaignUrl: noBonusLargeImg,
    campaignSmallUrl: noBonusSmallImg,
  },
  noPromotionsAvailable: {
    campaignUrl: completedLargeImg,
    campaignSmallUrl: completedSmallImg,
  },
  promoCode: {
    campaignUrl: promoCodeLargeImg,
    campaignSmallUrl: promoCodeSmallImg,
  },
}

export const useLayoutStore = defineStore('layout', () => {
  // State
  const layoutConfig = ref({})
  const currentLocale = ref('en-US')

  // Basic getters
  const panel = computed(() => layoutConfig.value?.panel || [])
  const mainMenu = computed(() => layoutConfig.value?.mainMenu || [])
  const quickLayout = computed(() => layoutConfig.value?.quickLayout || [])

  // Panel filter function
  const filterPanelData = (locale, type) => {
    const panelList = panel.value
    const item = panelList.find((item) => item.panelType === type && item.locale === locale)
    const defaultCampaign = campaignDefaultMapping[type]?.campaignUrl || ''
    const defaultCampaignSmall = campaignDefaultMapping[type]?.campaignSmallUrl || ''

    return {
      campaignUrl: item?.campaignUrl ? item.campaignUrl[0]?.url || defaultCampaign : defaultCampaign,
      campaignSmallUrl: item?.campaignSmallUrl ? item.campaignSmallUrl[0]?.url || defaultCampaignSmall : defaultCampaignSmall,
      description: item?.description || '',
      descriptionUrl: item?.descriptionUrl || [],
      descriptionTitle: item?.descriptionTitle || '',
      isEmpty: !item,
    }
  }

  // Panel content computed (響應 locale 變化)
  const noBonus = computed(() => filterPanelData(currentLocale.value, 'noBonus'))
  const noPromotionsAvailable = computed(() => filterPanelData(currentLocale.value, 'noPromotionsAvailable'))
  const promoCode = computed(() => filterPanelData(currentLocale.value, 'promoCode'))
  const bankDepositInstructionsPage = computed(() => filterPanelData(currentLocale.value, 'bankDepositInstructionsPage'))
  const qRCodeDepositInstructionsPage = computed(() => filterPanelData(currentLocale.value, 'qRCodeDepositInstructionsPage'))
  const faq = computed(() => filterPanelData(currentLocale.value, 'faq'))

  // Actions
  function setLayoutConfig(data) {
    layoutConfig.value = data
  }

  function setLocale(locale) {
    currentLocale.value = locale
  }

  return {
    // State
    layoutConfig,
    currentLocale,
    // Basic getters
    panel,
    mainMenu,
    quickLayout,
    // Panel content getters
    noBonus,
    noPromotionsAvailable,
    promoCode,
    bankDepositInstructionsPage,
    qRCodeDepositInstructionsPage,
    faq,
    // Actions
    setLayoutConfig,
    setLocale,
  }
})
